import { AdminRole } from "types/auth";
import { create } from "zustand";

export const lowPoolParamKeys = {
  isShowLowAllPools: "isShowLowAllPools",
  isShowParticipantLowPools: "isShowParticipantLowPools",
  isShowCreatorLowPools: "isShowCreatorLowPools",
};

const getInitialIsShowLowPools = (field) => {
  const savedState = localStorage.getItem(field);

  return savedState ? JSON.parse(savedState) : "hide";
};

export const appStore = create((set) => ({
  selectedPool: null,
  admin: null,
  setAdmin: (admin) => set({ admin }),
  redirectionToPoolMessage: null,
  tokensMarketCaps: null,
  setUsdtMarketCaps: (usdtMarketCaps) => set({ usdtMarketCaps }),
  setRedirectionToPoolMessage: (redirectionToPoolMessage) =>
    set({ redirectionToPoolMessage }),
  usdtMarketCaps: {},
  setTokensMarketCaps: (tokensMarketCaps) => set({ tokensMarketCaps }),
  setSelectedPool: (selectedPool) => set({ selectedPool }),
  isShowAllPools: false,
  setIsShowAllPools: (val) => set({ isShowAllPools: val }),
  errorMessage: "",
  setErrorMessage: (errorMessage) => set({ errorMessage }),
  allPoolsTokens: null,
  setAllPoolsTokens: (allPoolsTokens) => set({ allPoolsTokens }),

  isShowLowAllPools: getInitialIsShowLowPools(
    lowPoolParamKeys.isShowLowAllPools
  ),
  setShowLowAllPools: (isShowLowAllPools) => set({ isShowLowAllPools }),

  isShowParticipantLowPools: getInitialIsShowLowPools(
    lowPoolParamKeys.isShowParticipantLowPools
  ),
  setShowParticipantLowPools: (isShowParticipantLowPools) =>
    set({ isShowParticipantLowPools }),

  isShowCreatorLowPools: getInitialIsShowLowPools(
    lowPoolParamKeys.isShowCreatorLowPools
  ),
  setShowCreatorLowPools: (isShowCreatorLowPools) =>
    set({ isShowCreatorLowPools }),
}));

export const useAppStore = appStore;
